__turbopack_context__.v({
  "actionButton": "ILSldq_actionButton",
  "actions": "ILSldq_actions",
  "active": "ILSldq_active",
  "badge": "ILSldq_badge",
  "badgeDelayed": "ILSldq_badgeDelayed",
  "badgeInProgress": "ILSldq_badgeInProgress",
  "badgeLive": "ILSldq_badgeLive",
  "closeButton": "ILSldq_closeButton",
  "column": "ILSldq_column",
  "columnTitle": "ILSldq_columnTitle",
  "contactDetails": "ILSldq_contactDetails",
  "content": "ILSldq_content",
  "detailLabel": "ILSldq_detailLabel",
  "detailValue": "ILSldq_detailValue",
  "drawer": "ILSldq_drawer",
  "header": "ILSldq_header",
  "locationBlock": "ILSldq_locationBlock",
  "locationName": "ILSldq_locationName",
  "locationTimes": "ILSldq_locationTimes",
  "open": "ILSldq_open",
  "organizationRow": "ILSldq_organizationRow",
  "referenceLinkButton": "ILSldq_referenceLinkButton",
  "shareHeader": "ILSldq_shareHeader",
  "shareItem": "ILSldq_shareItem",
  "sharesColumn": "ILSldq_sharesColumn",
  "sharesDetailValue": "ILSldq_sharesDetailValue",
  "statusBadge": "ILSldq_statusBadge",
  "statusIcon": "ILSldq_statusIcon",
  "tab": "ILSldq_tab",
  "tabs": "ILSldq_tabs",
  "tagsList": "ILSldq_tagsList",
  "taskCard": "ILSldq_taskCard",
  "taskItem": "ILSldq_taskItem",
  "taskList": "ILSldq_taskList",
  "timeItem": "ILSldq_timeItem",
});
